module.exports = __webpack_public_path__ + "img/marc.aba54d65.jpg";